import { get } from 'lodash'
import React, { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

import { FieldPrefix } from '../../../../../../1stlog-ui/src/components/Field'
import useFieldValue from '../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import FieldArray, {
  useFieldArray,
} from '../../../../../../1stlog-ui/src/components/FieldArray'
import ListGroup, {
  ListGroupItem,
} from '../../../../../../1stlog-ui/src/components/ListGroup'
import Coli from '../Coli'

const ListGroupItemCustom = styled(ListGroupItem)`
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  // margin-bottom: -5px;
`

type TColiGroupProps = {
  readonly?: boolean
  disableColiCountChange?: boolean
}

const ColiGroup = (props: TColiGroupProps): ReactElement => {
  const { readonly, disableColiCountChange } = props

  const { fields: coliFields } = useFieldArray('colis')
  const colis = useFieldValue('colis')

  const duplicateColi = (index: number): void => {
    const newColi = {
      ...get(colis, index),
      barcode: undefined,
      barcode1: undefined,
    }
    coliFields.push(newColi)
    // focus new element
    setTimeout(() => {
      try {
        document
          .getElementById(`coli_${coliFields.length}`)
          ?.scrollIntoView({ behavior: 'smooth' })
      } catch (err) {
        //
      }
    }, 0)
  }

  const removeColi = (index: number): void => {
    if (index === 0) {
      return
    }
    coliFields.remove(index)
    // focus previous element
    setTimeout(() => {
      try {
        document
          .getElementById(`coli_${index - 1}`)
          ?.scrollIntoView({ behavior: 'smooth' })
      } catch (err) {
        //
      }
    }, 0)
  }

  return (
    <div className="m-n1">
      <FieldArray name="colis">
        {({ fields }): ReactNode => (
          <ListGroup flush>
            {fields.map((name: string, index: number) => (
              <ListGroupItemCustom key={name}>
                <FieldPrefix prefix={name} overwritePrefix>
                  <Coli
                    index={index}
                    readonly={readonly}
                    onDuplicate={
                      !disableColiCountChange ? duplicateColi : undefined
                    }
                    onRemove={!disableColiCountChange ? removeColi : undefined}
                  />
                </FieldPrefix>
              </ListGroupItemCustom>
            ))}
          </ListGroup>
        )}
      </FieldArray>
    </div>
  )
}

export default ColiGroup
